import { useState, useEffect } from "react";
import { getobj, updateobj, postobj } from "../../apicall/apicall";
import { Box, Button, MenuItem, TextField } from "@mui/material";
import { buttonPosition } from "../../style/style";
import { test_data } from "../../apicall/testdata";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { NotificationManager } from "react-notifications";
import NotificationContainer from "react-notifications/lib/NotificationContainer";
import { Switch } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { TableRow } from "@mui/material";

export default function Endpoint(props) {
  const [refreshed, setrefreshed] = useState(false);
  const [basic, setbasic] = useState();
  const [loaded, setloaded] = useState(true);
  const [obj, setobj] = useState("");
  const [test, settest] = useState(false);
  const [test_device, settestdevice] = useState();
  const [checked, setchecked] = useState();
  const [df, setdf] = useState({
    id: props.id,
    data_forwarding_url: "",
    token: "",
  });

  const handletestforwarding = async (data) => {
    const url = basic.data_forwarding_url;
    const local_url = process.env.REACT_APP_ZEWA_URL + "device/send-test-data/";
    let payload = {};
    payload["data"] = test_data[test_device];
    payload["dfu"] = url;
    payload["token"] = basic.token;

    console.log(data);
    if (url !== "") {
      let res = postobj(local_url, payload);

      res.then(function (res) {
        if (res.status >= 400) {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error(res.statusText, "Failed", 2000);
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success("Data Sent", "Sent", 2000);
          settest(false);
          // console.log(res);
        }
      });
    }
  };

  useEffect(() => {
    const url =
      process.env.REACT_APP_ZEWA_URL + "user/get-customer/" + props.id + "/";
    const d = getobj(url);
    d.then(function (res) {
      setbasic(res.data);
      setchecked(res.data.data_forwarding_status);
      //console.log(res);

      setloaded(false);
    });
  }, [props.id, refreshed]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(df, value);
    setdf({
      ...df,
      [name]: value,
    });
    console.log("inside handle change");
  };
  const handleClick = async (data) => {
    const url = process.env.REACT_APP_ZEWA_URL + "user/customer-profile/";
    return updateobj(url, data).then((d) => {
      if (d.status === 200) {
        console.log("Success:", d);
      } else {
        console.log("Error:", d);
      }
      if (!Object.keys(data).includes("data_forwarding_status")) {
        setdf({
          id: props.id,
          data_forwarding_url: "",
          token: "",
        });
      }
      setrefreshed(!refreshed);
      return d; // Return the response
    });
  };
  const handleDFS = (e) => {
    const previousChecked = checked; // Store the previous state
    const newChecked = e.target.checked; // Get the new state
    setchecked(newChecked); // Optimistically update the state

    handleClick({ id: props.id, data_forwarding_status: newChecked })
      .then((response) => {
        if (response.status !== 200) {
          // If the API call fails, revert to the previous state
          setchecked(previousChecked);
          NotificationManager.error("Failed to update Data Forwarding Status.");
        } else {
          NotificationManager.success(
            "Data Forwarding Status updated successfully.",
          );
        }
      })
      .catch((error) => {
        // Handle any errors and revert the state
        console.error("Error updating Data Forwarding Status:", error);
        setchecked(previousChecked);
        NotificationManager.error(
          "An error occurred while updating the status.",
        );
      });
  };

  const handleSelectChange = (e) => {
    setobj(e.target.value);
    setdf({
      id: props.id,
      data_forwarding_url: "",
      token: "",
    });
  };

  return (
    <div>
      <Box>
        <Box sx={buttonPosition}>
          <Button
            sx={buttonPosition}
            variant="contained"
            color="primary"
            onClick={() => {
              settest(true);
            }}
          >
            test
          </Button>
        </Box>

        {loaded ? (
          <img
            src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif"
            alt="loading..."
          />
        ) : (
          basic && (
            <TableContainer>
              <Table
                sx={{ minWidth: 650 }}
                size="small"
                aria-label="a dense table"
              >
                <TableBody>
                  <TableRow>
                    <TableCell> Data Forwarding URL:</TableCell>{" "}
                    <TableCell>{basic.data_forwarding_url}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Data Forwarding Status</TableCell>
                    <TableCell>
                      {basic.data_forwarding_status ? "ON" : "OFF"}
                    </TableCell>
                    <TableCell>
                      {" "}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <p style={{ visibility: "hidden" }}></p>
                        <Switch
                          checked={checked}
                          onChange={handleDFS}
                          name="status"
                          inputProps={{ "aria-label": "controlled" }}
                        ></Switch>
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Token</TableCell>
                    <TableCell>{basic.token}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          )
        )}
        <Box>
          <TextField
            select
            label="Select Input Parameter"
            id="deviceName"
            sx={{ width: "100%", maxWidth: "400px", margin: "0.3125rem" }}
            variant="outlined"
            value={obj}
            onChange={handleSelectChange}
          >
            <MenuItem value="token">Token</MenuItem>
            <MenuItem value="data_forwarding_url">Data Forwarding URL</MenuItem>
            <MenuItem value="both">Both</MenuItem>
          </TextField>
          <br />
          {obj && obj !== "both" ? (
            <div>
              {" "}
              {obj === "token" ? (
                <TextField
                  id="outlined-basic"
                  label={"Enter " + obj}
                  variant="outlined"
                  name={"token"}
                  value={df?.token}
                  sx={{ width: "100%", maxWidth: "400px", margin: "0.3125rem" }}
                  onChange={handleChange}
                />
              ) : (
                <TextField
                  id="outlined-basic"
                  label={"Enter " + obj}
                  variant="outlined"
                  name={"data_forwarding_url"}
                  value={df?.data_forwarding_url}
                  sx={{ width: "100%", maxWidth: "400px", margin: "0.3125rem" }}
                  onChange={handleChange}
                />
              )}
              <br />
            </div>
          ) : (
            <div>
              <TextField
                id="outlined-basic"
                label={"Enter Data Forwarding URL"}
                variant="outlined"
                name={"data_forwarding_url"}
                sx={{ width: "100%", maxWidth: "400px", margin: "0.3125rem" }}
                onChange={handleChange}
              />
              <br />
              <TextField
                id="outlined-basic"
                label={"Enter Token"}
                variant="outlined"
                name={"token"}
                sx={{ width: "100%", maxWidth: "400px", margin: "0.3125rem" }}
                onChange={handleChange}
              />
            </div>
          )}
          <Button
            variant="contained"
            color="primary"
            sx={{ margin: "5px" }}
            onClick={() => handleClick(df)}
          >
            Add
          </Button>
        </Box>
      </Box>
      <NotificationContainer />
      <Dialog open={test} onClose={() => settest(false)}>
        <DialogTitle>Test Data forwarding</DialogTitle>

        <TextField
          select
          label="Select Device"
          name="device_group"
          id="deviceName"
          sx={{ width: "100%", maxWidth: "400px", margin: "0.3125rem" }}
          variant="outlined"
          value={test_device}
          onChange={(e) => {
            settestdevice(e.target.value);
          }}
        >
          {Object.keys(test_data).map((i) => {
            return <MenuItem value={i}>{i}</MenuItem>;
          })}
        </TextField>
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              settest(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              // console.log("clicked");
              handletestforwarding(basic);
            }}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
